import React from 'react'
import { Link } from 'react-router-dom'

import { LOGO_TOP_BAR_NAME, CUSTOM_LOGO_URL } from 'api/constants'

const LogoIMGComponent = ({ src }) => (
  <Link to="/">
    <img src={src} alt="" />
  </Link>
)

const getHeaderConfig = () => {
  const headerConfig = {
    withInfotechLogo: true,
    topBarName: `Resultat`,
  }
  if (LOGO_TOP_BAR_NAME) {
    headerConfig.topBarName = LOGO_TOP_BAR_NAME
  }
  if (CUSTOM_LOGO_URL) {
    headerConfig.topBarName = ``
    headerConfig.withInfotechLogo = false
    headerConfig.Logo = () => <LogoIMGComponent src={CUSTOM_LOGO_URL} />
  }
  return headerConfig
}

export default getHeaderConfig
